import { html, ref } from '@microsoft/fast-element';
import { eventDetail } from '../../utils/formatting';
import type { BuyerDashboard } from './buyer-dashboard';
import { hasPermission } from '../../utils/profiles';
import { PROFILE_RIGHTS } from '../../utils';

export const BuyerDashboardTemplate = html<BuyerDashboard>`
  <div class="cascade-route-content">
    <div class="dashboard-grid">
      <div>
        <zero-card class="no-padding-card">
          <my-portfolio
            @openRfqModal="${(x, c) => x.openRfqModal()}"
            @deleteRfq="${(x, c) => x.openCancelModal(eventDetail(c))}"
            @copyRfq="${(x, c) => x.copyRfq(eventDetail(c))}"
            @editRfq="${(x, c) => x.editRfq(eventDetail(c))}"
            @reviewProposal="${(x, c) => x.reviewProposal(eventDetail(c))}"
            @clearRejected="${(x, c) => x.clearRejected(eventDetail(c))}"
            @reviewAndClearRejected="${(x, c) => x.reviewAndClearRejected(eventDetail(c))}"
            @goToArteria="${(x, c) => x.goToArteriaPage(eventDetail(c))}"
            @goToExecution="${(x, c) => x.goToExecutionPage(eventDetail(c))}"
            @vppaFromLinkedRfq=${(x, c) => x.getCurrentVppa(eventDetail(c))}
            @goToArteriaNegotiationsPage="${(x, c) =>
              x.goToArteriaNegotiationsPage(eventDetail(c))}"
            @openMoreInfoModal="${(x, c) => x.openMoreInfoModal(eventDetail(c))}"
          >
            >
          </my-portfolio>
        </zero-card>
      </div>

      <zero-card
        class="watchlist-card no-padding-card"
        style="display: ${(x) =>
          hasPermission(x.userService.getFilteredPermissions(), PROFILE_RIGHTS.BUYER_VISIBILITY)
            ? ''
            : 'none'}"
      >
        <watchlist-container
          ${ref('watchlistElement')}
          @vppaRowSelected=${(x, c) => x.getCurrentVppa(eventDetail(c))}
        ></watchlist-container>
      </zero-card>

      <div
        class="card-group-2"
        style="grid-template-columns: ${(x) => (x.isExpandedView ? '3fr 1fr;' : '1fr 1.3fr;')}"
      >
        <zero-card
          class="no-padding-card"
          style="display: ${(x) =>
            hasPermission(x.userService.getFilteredPermissions(), PROFILE_RIGHTS.BUYER_VISIBILITY)
              ? ''
              : 'none'}"
        >
          <seller-interest
            @favoriteSellerInterestVppa="${(x, c) => x.favoriteSellerInterestVppa(eventDetail(c))}"
            @expandSellerInterest="${(x, c) => (x.isExpandedView = eventDetail(c))}"
            @vppaSelected="${(x, c) => (x.selectedVppa = eventDetail(c))}"
          ></seller-interest>
        </zero-card>

        <zero-card>
          <h3 class="market-index-title">
            Market Index Performance
            ${(x) => (x.selectedVppa?.TICKER ? x.selectedVppa.TICKER + '-' : '')}${(x) =>
              x.selectedVppa?.UNIQUE_ID}
          </h3>
          <market-performance-graph
            ${ref('marketPerformanceGraph')}
            :vppaId=${(x) => x.selectedVppa?.VPPA_ID}
          ></market-performance-graph>
        </zero-card>
      </div>
    </div>
  </div>

  <rfq-modal ${ref('rfqModal')}></rfq-modal>
  <more-info-modal ${ref('moreInfoModal')}></more-info-modal>

  <cancel-modal
    ${ref('cancelModal')}
    @confirmCancel="${(x, c) => x.cancelRfq(eventDetail(c))}"
  ></cancel-modal>
`;
